import { useEffect, useState } from "react";
import { getCourseCategoriesWithPublishCourses } from "../services/Course";
import { PleasewaitPopup } from "./PleasewaitPopup";
import { post_Class } from "../services/Class";
import useAuth from "../hook/useAuth";

type AddClassProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshClassList: (value: boolean) => void;
}


export const AddClass = ({ showPopup, setShowPopup, setRefreshClassList }: AddClassProps) => {
    const { auth }: any = useAuth();
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [classTitle, setClassTitle] = useState<string>("");
    const [classDiscription, setClassDiscription] = useState<string>("");
    const [selectedCourse, setSelectedCourse] = useState<number>(0);
    const [filterCourseList, setFilterCourseList] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [courseList, setCourseList] = useState<any[]>([]);
    const [courseDataLoaded, setCourseDataLoaded] = useState<boolean>(false);
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    useEffect(() => {

        const filteredCourses = courseList
            .map((category) => ({
                ...category,
                courses: category.courses.filter((course: any) =>
                    course?.title.toLowerCase().includes(searchValue.toLowerCase())
                ),
            }))
            .filter((category) => category.courses.length > 0);

        setFilterCourseList(filteredCourses)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue])

    if (!showPopup) return null;

    const handleNextClick = () => {
        if (currentStep === 1 && classTitle) {
            setCurrentStep(2);
            setCourseDataLoaded(false);
            getCourseCategoriesWithPublishCourses()
                .then((data) => {
                    const list = data
                        ?.filter((category: any) => category?.courses?.length > 0) // ✅ keep only categories with at least one course
                        .map((category: any) => ({
                            ...category,
                            courses: category.courses.map((item: any) => ({
                                ...item,
                            })),
                        }));

                    setCourseList(list);
                    setFilterCourseList(list);
                    setCourseDataLoaded(true);;
                })
                .catch((error) => {
                    setCourseList([]);
                    setFilterCourseList([]);
                    setCourseDataLoaded(true);
                    console.error(error);
                });

        }
        else if (currentStep === 2 && selectedCourse > 0) {
            setShowPleasewait(true)
            post_Class({
                teacherId: auth?.id,
                courseId: selectedCourse,
                title: classTitle,
                description: classDiscription,
                joinCode: classTitle,
                createdAt: new Date().toLocaleString(),
                createdBy: auth?.givenname
            }, auth?.id)
                .then((res) => {
                    setShowPleasewait(false);
                    setShowPopup(false);
                    setRefreshClassList(true);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    const handleBackClick = () => {
        if (currentStep === 2) {
            setCurrentStep(1);
        }
    }

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-3xl rounded-md shadow-lg max-h-[90vh] flex flex-col">

                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Add new class</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                                setCurrentStep(1);
                                setClassTitle("");
                                setClassDiscription("");
                                setSelectedCourse(0);
                                setCourseList([]);
                                setSearchValue("");
                                setFilterCourseList([]);
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>

                    {
                        currentStep === 1 && (
                            <>
                                <div className="px-6 pt-6 space-y-4">

                                    <label className="font-medium">Class Title</label>
                                    <input
                                        type="text"
                                        placeholder="e.g., Mr. David math class"
                                        className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                        value={classTitle}
                                        onChange={(e) => setClassTitle(e.target.value)}
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        This class name is what your students will see.
                                    </p>
                                </div>

                                <div className="px-6 py-6 space-y-4">
                                    <label className="font-medium">Class Description</label>
                                    <textarea
                                        rows={3}
                                        placeholder="Description"
                                        className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                        value={classDiscription}
                                        onChange={(e) => setClassDiscription(e.target.value)}
                                    />
                                </div>
                            </>

                        )
                    }

                    {
                        currentStep === 2 && (
                            <div className="px-6 py-6 overflow-y-auto flex-1">
                                <h3 className="text-lg font-medium mb-2">
                                    Which course do you want students to work on?
                                </h3>
                                <p className="text-sm text-gray-600 mb-4">
                                    Once you add a course, students will see it on their dashboard and
                                    can begin learning right away.
                                </p>

                                {/* Search box */}
                                <input
                                    type="text"
                                    placeholder="Search for a course"
                                    className="w-full border rounded px-3 py-2 mb-6 text-sm focus:outline-none focus:ring focus:ring-primary"
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />

                                {/* Course categories */}
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                                    {filterCourseList?.map((item: any, index: number) => (
                                        <div key={index}>
                                            <h4 className="font-medium border-b pb-1 mb-2 uppercase">{item?.name}</h4>
                                            <div className="space-y-2">
                                                {item?.courses?.map((course: any, idx: number) => (
                                                    <label
                                                        key={idx}
                                                        className="flex items-center space-x-2 text-sm cursor-pointer"
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="course"
                                                            value={course?.id}
                                                            checked={selectedCourse === course?.id}
                                                            onChange={() => setSelectedCourse(course?.id)}
                                                        />
                                                        <span>{course?.title}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    ))}


                                </div>
                                {
                                    !courseDataLoaded && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <div className="mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                        </div>
                                    )
                                }

                                {
                                    (courseDataLoaded && filterCourseList.length === 0) && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <span className="text-lg text-gray-400">No course found!</span>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }



                    {/* Footer */}
                    <div className="px-6 py-4 border-t flex justify-between space-x-3">
                        <button
                            className={`px-6 py-2 ${currentStep === 1 ? "bg-gray-300 text-white cursor-not-allowed" : currentStep === 2 ? "bg-white text-primary border border-primary cursor-pointer" : "bg-gray-300 text-white cursor-not-allowed"}  font-medium rounded`}
                            disabled={currentStep === 1 ? true : currentStep === 2 ? false : true}
                            onClick={handleBackClick}
                        >
                            Back
                        </button>

                        <button
                            className={`px-6 py-2 ${currentStep === 1 && !classTitle ? "bg-gray-300 text-white cursor-not-allowed" : currentStep === 2 && selectedCourse === 0 ? "bg-gray-300 text-white cursor-not-allowed" : "bg-primary text-white cursor-pointer"}  font-medium rounded`}
                            disabled={currentStep === 1 && !classTitle ? true : currentStep === 2 && selectedCourse === 0 ? true : false}
                            onClick={handleNextClick}
                        >
                            {currentStep === 2 && selectedCourse > 0 ? "Save" : "Next"}
                        </button>
                    </div>
                </div>
            </div >
            <PleasewaitPopup showPopup={showPleasewait} />
        </>

    )
}